import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';
import { getColumnDefinitions } from '../../shared/columnDefinitions/accountBalances';
import { removeSpaces } from '@common/utils/fileNameHelpers';

export default ({
  periodName,
  groupType,
  accountBalances,
  selectedSlAccounts,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
  environmentSuffix,
}) => {
  const columnDefinitions = getColumnDefinitions(groupType.value);
  const selectedAccounts = selectedSlAccounts.map(account => account.label).join(', ');

  const sheetData = [{
    name: 'Account Balances',
    type: SheetExportTypes.GRID,
    columnDefinitions,
    data: accountBalances,
    options: {
      shouldDisplayZero,
      hideDecimals,
      negativeMinus,
    },
  }];

  xlsxExport({
    sheetData,
    metadata: {
      fileName: removeSpaces(`TLS_Account_Balances_${periodName}_${groupType.label}${environmentSuffix}`),
      description: `${periodName}, ${groupType.label}, Accounts: ${selectedAccounts}`,
    },
  });
};
